<template>
  <v-footer
    id="home-footer"
    color="transparent"
    padless
  >
    <div class="hh-spectrum-bar" />

    <v-container class="py-12">
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <div class="hh-logo mb-3">
            <span class="hh-logo__brace hh-logo__brace--open">{</span>
            <span class="hh-logo__name">Hacker Hang</span>
            <span class="hh-logo__brace hh-logo__brace--close">}</span>
          </div>
          <p class="hh-muted mb-4 hh-footer__blurb">
            An AI media company in Melbourne, Florida. We build AI agents, React Native apps, and social platforms, and we ship our own.
          </p>
          <a
            class="hh-footer__link"
            href="mailto:info@hackerhang.com"
          >info@hackerhang.com</a>
        </v-col>

        <v-col
          v-for="group in groups"
          :key="group.title"
          cols="6"
          md="2"
        >
          <div class="hh-footer__title">
            {{ group.title }}
          </div>
          <div
            v-for="link in group.links"
            :key="link.text"
            class="mb-2"
          >
            <router-link
              v-if="link.to"
              :to="link.to"
              class="hh-footer__link"
            >
              {{ link.text }}
            </router-link>
            <a
              v-else
              :href="link.href"
              class="hh-footer__link"
              rel="noopener"
              target="_blank"
            >
              {{ link.text }}
            </a>
          </div>
        </v-col>
      </v-row>

      <v-divider class="my-8" />

      <div class="d-flex flex-wrap justify-space-between hh-muted hh-footer__meta">
        <span>Copyright &copy; {{ year }} Hacker Hang, LLC</span>
        <span>Melbourne, FL</span>
      </div>
    </v-container>
  </v-footer>
</template>

<script>
  export default {
    name: 'HomeFooter',

    data: () => ({
      year: new Date().getFullYear(),
      groups: [
        {
          title: 'Products',
          links: [
            { text: 'VividMotion', href: 'https://vividmotion.io' },
            { text: 'Total Chaos', href: 'https://apps.apple.com/us/app/total-chaos/id6760237060' },
            { text: 'Total Chaos support', to: '/support/totalchaos' },
          ],
        },
        {
          title: 'Company',
          links: [
            { text: 'Products', to: { name: 'Products' } },
            { text: 'Vision', to: { name: 'Vision' } },
            { text: 'Contact', to: { name: 'Contact' } },
          ],
        },
        {
          title: 'Legal',
          links: [
            { text: 'Privacy policy', to: '/privacy-policy' },
            { text: 'Terms of service', to: '/terms-of-service' },
            { text: 'Data deletion', to: '/data-deletion' },
            { text: 'Total Chaos privacy', to: '/privacy-policy/totalchaos' },
          ],
        },
      ],
    }),
  }
</script>

<style lang="sass">
  #home-footer
    border-top: none

    .hh-footer__blurb
      max-width: 34em
      line-height: 1.6

    .hh-footer__title
      font-family: var(--hh-font-display)
      font-weight: 500
      font-size: 1.15rem
      margin-bottom: 12px
      color: var(--hh-text)

    .hh-footer__link
      color: var(--hh-muted) !important
      text-decoration: none

      &:hover
        color: var(--hh-cyan) !important

    .hh-footer__meta
      font-size: .9rem
      gap: 8px
</style>
